import Styles from './FlipperOverrideModal.module.scss'
import { Modal } from 'almanac-ui/Modal'
import { FlipperOverrideList } from './components/FlipperOverrideList'

export const FlipperOverrideModal = () => (
  <Modal.Root size="md">
    <Modal.Header title="Override feature flags" />
    <Modal.Content>
      <ul className={Styles.list}>
        <li className={Styles.listItem}>
          Toggling a feature will override the settings from Flipper and save them in your browser's local storage,
          which will persist across refreshes.
        </li>
        <li className={Styles.listItem}>
          You can reset any individual setting back to the Flipper default, or you can reset all of them at once to get
          back to a production state for your user.
        </li>
        <li className={Styles.listItem}>Refresh your browser to ensure the changes propagate everywhere.</li>
      </ul>
      <FlipperOverrideList />
    </Modal.Content>
  </Modal.Root>
)
